export type ProgressBarProps = {
  /** The current amount toward `max`. */
  value: number
  /**  The maximum amount. */
  max: number
  /** The minimum percentage to show the progress bar. Defaults to 0. */
  minVisiblePercent?: number
}

export function ProgressBar({ value, max, minVisiblePercent = 0 }: ProgressBarProps) {
  let percent = 0

  if (max > 0) {
    const ratio = Math.min(1, Math.max(0, value / max))
    percent = Math.min(100, Math.max(minVisiblePercent, Math.round(ratio * 100)))
  }

  // If the max is 0 or the progress is complete, hide the progress bar
  if (max <= 0 || percent >= 100) {
    return <div data-ds-component="ProgressBar" className="h-[3px] w-full" aria-hidden />
  }

  return (
    <div
      data-ds-component="ProgressBar"
      className="relative h-[3px] w-full overflow-hidden rounded-[4px]"
      role="progressbar"
      aria-valuenow={Math.min(max, Math.max(0, value))}
      aria-valuemin={0}
      aria-valuemax={max}
    >
      <div className="absolute inset-0 bg-brand-neutral-400" />
      <div className="absolute left-0 top-0 bottom-0 bg-brand-500" style={{ width: `${percent}%` }} />
    </div>
  )
}
